import styled from 'styled-components';

export const FixedCell = styled.td<{ showShadow?: boolean }>(({ showShadow, theme }) => ({
  position: 'sticky',
  left: 0,
  zIndex: 1,
  background: 'inherit',

  '&::after': {
    bottom: 0,
    content: showShadow ? "''" : undefined,
    position: 'absolute',
    right: -15,
    top: 0,
    width: 15,
    zIndex: 1,
    boxShadow: `inset 15px 0 15px -15px ${theme.colors.neutral['300']}`,
  },
}));
